module.exports = "\n  <ul class=\"accordion\">\n    <slot></slot>\n  </ul>\n"